import { render, staticRenderFns } from "./LDropdownItem.vue?vue&type=template&id=73a88b32&scoped=true"
import script from "./LDropdownItem.vue?vue&type=script&lang=js"
export * from "./LDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./LDropdownItem.vue?vue&type=style&index=0&id=73a88b32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a88b32",
  null
  
)

export default component.exports